


class Tool {
  //时间转换成时间戳
  timeString(t) {
    t = t.replace("-", "/").replace("-", "/"); 
    let newtime = new Date(t);
    // console.log(newtime)
    return newtime.getTime()
  }
  //时间戳转换成时间
  timeNum(date, fmt) {
    let time = new Date(date)
    var o = {
      "M+": time.getMonth() + 1, //月份 
      "d+": time.getDate(), //日 
      "h+": time.getHours(), //小时 
      "m+": time.getMinutes(), //分 
      "s+": time.getSeconds(), //秒 
      "q+": Math.floor((time.getMonth() + 3) / 3), //季度 
      "S": time.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  isToday (date){
    return new Date().toDateString() === new Date(date).toDateString();
  }

  // drawPage(total, pagesLen, cur) {
  //   // console.log(total, pagesLen, cur)
  //   // 可显示页码数 =  页码个数 - (首页|尾页 + 一个省略号)
  //   var temp = pagesLen - 2;

  //   // 显示页码数组
  //   let pagesNum = [];

  //   // 如果total总数小于页码个数，我们就采用total总数
  //   if (total <= pagesLen) {
  //     for (var i = 0; i < total; i++) {
  //       pagesNum.push(i + 1);
  //     }
  //   } else {
  //     // 如果total大于页码总数,则需要分为三种情况

  //     // 1、 第一种，当前页码是否小于 temp (temp为 页码数 - 2)
  //     if (cur <= temp) {
  //       // 当前页码离首页稍近的时候，尾部显示省略号
  //       if (cur <= temp - Math.ceil(temp / 2)) {
  //         for (var i = 0; i < temp; i++) {
  //           pagesNum.push(i + 1);
  //         }
  //         pagesNum.push('...', total);
  //       } else {
  //         // 当前页码离首页较远的时候，出现两边省略号
  //         pagesNum = this.around(total, pagesLen, cur);
  //       }

  //       // 2. 第二种，当前页码是否大于 总数 - temp,
  //     } else if (cur >= total - temp) {
  //       // 当前页码离尾页稍近的时候，首部显示省略号
  //       if (cur >= total - Math.floor(temp / 2)) {
  //         for (var i = 0; i < temp; i++) {
  //           pagesNum.unshift(total - i);
  //         }
  //         pagesNum.unshift(1, '...')
  //       } else {
  //         // 当前页码离尾页页较远的时候，出现两边省略号
  //         pagesNum = this.around(total, pagesLen, cur);
  //       }

  //     } else {
  //       // 如果以上情况不成立，则显示两个省略号
  //       pagesNum = this.around(total, pagesLen, cur);
  //     }
  //   }
  //   return pagesNum;
  // }

  // around(total, pagesLen, cur) {
  //   let pagesNum = [];
  //   let side = (pagesLen - 5) / 2;
  //   // 左边的数组
  //   let leftArr = [],
  //     // 右边的数组
  //     rightArr = [];

  //   // 左右两边都匀称
  //   for (var i = 1; i <= side; i++) {
  //     leftArr.unshift(cur - i);
  //     rightArr.push(cur + i);
  //   }
  //   // 考虑一下 如何不能整除，我们可以视情况而定，添加一个在左边，或者右边
  //   pagesNum = (pagesLen - 5) % 2 === 0 ? [1, '...'].concat(leftArr, cur, rightArr, '...', total) : [1, '...'].concat(cur - Math.ceil(side), leftArr, cur, rightArr, '...', total);
  //   return pagesNum;
  // }

  // // 点击事件
  // pages(e,num) {
  //   let pages = document.getElementById('pages')
  //   // 页码的个数：比如9
  //   let pagesSum = pages.children.length;
  //   let tar = e.target;
  //   let pageTotal = num;
  //   if (tar.nodeName === 'LI') {
  //     let numTxt = tar.innerText;
  //     // 如果是... 就直接返回
  //     if (numTxt === '...') return;

  //     // 改变页码
  //     this.changePage(pageTotal, pagesSum, numTxt * 1);
  //     // 给对应的页码加上高亮
  //     for (var i = 0; i < pages.children.length; i++) {
  //       pages.children[i].className = pages.children[i].innerText === numTxt ? 'current' : '';
  //     }
  //   }
  // }

  // // 改变页码
  // changePage(total, pagesLen, cur) {
  //   // 生成页码
  //   // console.log(total, pagesLen, cur)
  //   let nums = this.drawPage(total, pagesLen, cur);
  //   for (var i = 0; i < pages.children.length; i++) {
  //     // 将页码绘制对应位置上
  //     pages.children[i].innerText = nums[i];
  //   }
  // }

  // nextPage(total, pagesLen, cur){
  //   let nums = this.drawPage(total, pagesLen, cur);
  //   for (var i = 0; i < pages.children.length; i++) {
  //     // 将页码绘制对应位置上
  //     pages.children[i].innerText = nums[i-1];
  //   }
  // }
  


  // // 默认改变一次
  // // changePage(pageTotal, pagesSum);



}

export default new Tool()



// WEBPACK FOOTER //
// ./src/assets/commonjs/tool.js